<template>
    <div style="position: relative">
        <div>
            <figure class="image is-2by1" style="position: relative">
                <img :src="image" />
                <button id="link" class="button is-light" @click="openURL">
                    <span class="icon">
                        <i class="fas fa-link" />
                    </span>
                </button>
            </figure>
        </div>
        <p
            :style="`padding-left:1rem;top:unset;background:${background}`"
            :class="{ 'has-text-white': backgroundLuminance < 0.55 }"
            class="is-overlay subtitle is-size-6"
        >
            {{ title }}
        </p>
    </div>
</template>

<script>
import { luminance } from '@/lib/helpers';
export default {
    props: {
        image: { type: String, default: undefined },
        title: { type: String, default: undefined },
        description: { type: String, default: undefined },
        url: { type: String, default: undefined },
    },
    data() {
        return {
            background: 'white',
        };
    },
    computed: {
        backgroundLuminance() {
            if (this.background) return luminance(this.background);
            else return 0;
            // return luminance(this.background);
        },
    },
    watch: {
        image: {
            handler() {},
            immediate: true,
        },
    },
    methods: {
        openURL() {
            window.open(this.url);
        },
    },
};
</script>

<style scoped>
img {
    object-fit: cover;
}
.subtitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
#link {
    top: 0;
    right: 0;
    position: absolute;
}
</style>
